import api from "@/config/api";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

type AccountingTransactionsAttachmentsResponse = {
    url: string;
    expiresAt: string;
    filename: string;
    contentType: string;
    cached: boolean;
};

const useQueryAccountingTransactionsAttachments = () => {
    const { oid, sid, rid } = useParams<Params>();
    const queryClient = useQueryClient();

    const fetchAccountingTransactionsAttachments = async (options?: { pdf?: boolean }) => {
        if (!oid || !sid || !rid) return;

        return queryClient.fetchQuery({
            queryKey: ["accounting-transactions-attachments", oid, sid, rid, !!options?.pdf],
            queryFn: async () => {
                try {
                    const endpoint = options?.pdf
                        ? `/organizations/${oid}/submissions/${sid}/reports/${rid}/shared/transactions/attachments-pdf`
                        : `/organizations/${oid}/submissions/${sid}/reports/${rid}/shared/transactions/attachments`;

                    const data = await api.get<AccountingTransactionsAttachmentsResponse>(endpoint, {
                        timeoutMs: 15 * 60000,
                    });
                    return data;
                } catch (e) {
                    log.error(e);
                }
            },
        });
    };

    return { fetchAccountingTransactionsAttachments };
};

export default useQueryAccountingTransactionsAttachments;
